package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Christmas Island Flag (32x24dp)
 *
 * - ISO Alpha-2: CX
 * - ISO Alpha-3: CXR
 * - ISO Numeric: 162
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.ChristmasIsland: ImageVector by lazy {
    ImageVector.Builder(
        name = "Christmas Island:CX:CXR:162:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF5EAA22)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(32f)
                verticalLineTo(24f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF4141DB)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                lineTo(32f, 24f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6f, 9f)
                lineTo(5f, 9.732f)
                lineTo(5.134f, 8.5f)
                lineTo(4f, 8f)
                lineTo(5.134f, 7.5f)
                lineTo(5f, 6.268f)
                lineTo(6f, 7f)
                lineTo(7f, 6.268f)
                lineTo(6.866f, 7.5f)
                lineTo(8f, 8f)
                lineTo(6.866f, 8.5f)
                lineTo(7f, 9.732f)
                lineTo(6f, 9f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4f, 15f)
                lineTo(3f, 15.732f)
                lineTo(3.134f, 14.5f)
                lineTo(2f, 14f)
                lineTo(3.134f, 13.5f)
                lineTo(3f, 12.268f)
                lineTo(4f, 13f)
                lineTo(5f, 12.268f)
                lineTo(4.866f, 13.5f)
                lineTo(6f, 14f)
                lineTo(4.866f, 14.5f)
                lineTo(5f, 15.732f)
                lineTo(4f, 15f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8f, 21f)
                lineTo(7f, 21.732f)
                lineTo(7.134f, 20.5f)
                lineTo(6f, 20f)
                lineTo(7.134f, 19.5f)
                lineTo(7f, 18.268f)
                lineTo(8f, 19f)
                lineTo(9f, 18.268f)
                lineTo(8.866f, 19.5f)
                lineTo(10f, 20f)
                lineTo(8.866f, 20.5f)
                lineTo(9f, 21.732f)
                lineTo(8f, 21f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9f, 11.5f)
                lineTo(8.5f, 11.866f)
                lineTo(8.567f, 11.25f)
                lineTo(8f, 11f)
                lineTo(8.567f, 10.75f)
                lineTo(8.5f, 10.134f)
                lineTo(9f, 10.5f)
                lineTo(9.5f, 10.134f)
                lineTo(9.433f, 10.75f)
                lineTo(10f, 11f)
                lineTo(9.433f, 11.25f)
                lineTo(9.5f, 11.866f)
                lineTo(9f, 11.5f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(21.561f, 12.224f)
                curveTo(21.187f, 11.834f, 24.551f, 10.918f, 24.9f, 9.736f)
                curveTo(25.362f, 8.707f, 25.053f, 7.874f, 23.307f, 7.142f)
                curveTo(21.561f, 6.41f, 19.796f, 4.994f, 21.826f, 4.994f)
                curveTo(23.855f, 4.994f, 23.855f, 5.284f, 24.4f, 6.137f)
                curveTo(24.945f, 6.991f, 26.124f, 7.173f, 26.149f, 6.137f)
                curveTo(26.149f, 4.371f, 26.315f, 4.134f, 24.89f, 2.599f)
                curveTo(23.464f, 1.063f, 28.464f, 3.229f, 28.051f, 5.861f)
                curveTo(27.638f, 8.493f, 27.14f, 7.643f, 27.456f, 8.085f)
                curveTo(27.772f, 8.527f, 29.672f, 7.156f, 29.435f, 8.982f)
                curveTo(28.77f, 10.033f, 27.451f, 11.596f, 21.561f, 12.224f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16f, 17f)
                curveTo(18.761f, 17f, 21f, 14.761f, 21f, 12f)
                curveTo(21f, 9.239f, 18.761f, 7f, 16f, 7f)
                curveTo(13.239f, 7f, 11f, 9.239f, 11f, 12f)
                curveTo(11f, 14.761f, 13.239f, 17f, 16f, 17f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF548650)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.953f, 10.162f)
                curveTo(13.52f, 10.036f, 14.296f, 11.554f, 15.695f, 10.985f)
                curveTo(17.095f, 10.415f, 17.387f, 9.328f, 18.052f, 9.726f)
                curveTo(18.718f, 10.124f, 18.805f, 11.082f, 18.362f, 11.564f)
                curveTo(17.919f, 12.045f, 17.167f, 12.159f, 17.167f, 12.768f)
                curveTo(17.167f, 13.377f, 17.02f, 15.547f, 16.732f, 14.918f)
                curveTo(15.871f, 14.219f, 16.396f, 13.106f, 15.335f, 12.768f)
                curveTo(14.274f, 12.43f, 13.629f, 12.441f, 12.846f, 12.584f)
                curveTo(12.063f, 12.726f, 13.372f, 12.192f, 13.65f, 11.685f)
                curveTo(14.215f, 11.141f, 12.694f, 10.343f, 12.953f, 10.162f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun ChristmasIslandPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.ChristmasIsland,
            contentDescription = "Christmas Island Flag"
        )
    }
}
